(() => {
  const story = document.querySelector('[data-shopsta-story]');
  if (!story) return;
  // Return explicitly to the purchase area: focusing the page-sized #site-main
  // wrapper can leave the viewport inside the story after other anchor handlers run.
  story.querySelectorAll('.oa-choose[href="#site-main"]').forEach(link => {
    link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = document.querySelector('#site-main .product-main') || document.getElementById('site-main');
      if (!target) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const siteHeader = document.querySelector('[data-site-header]');
      const clearance = siteHeader ? siteHeader.getBoundingClientRect().height : 0;
      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - clearance - 16);
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({preventScroll:true});
      window.scrollTo({top, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }, {capture:true});
  });
  const nav = story.querySelector('.oa-nav');
  const header = document.querySelector('[data-site-header]');
  const links = [...story.querySelectorAll('.oa-nav-links a')];
  const navLinks = story.querySelector('.oa-nav-links');
  let previousActive = -1, previousNavWidth = -1;
  const targets = links.map(link => document.getElementById(link.hash.slice(1)));
  let scheduled = false, previousOffset = -1, previousHeight = -1, previousCartHeight = -1;
  const update = () => {
    scheduled = false;
    const rect = header?.getBoundingClientRect();
    const offset = rect && rect.top <= 1 ? Math.max(0,rect.bottom) : 0;
    const height = getComputedStyle(nav).position === 'sticky' ? nav.getBoundingClientRect().height : 0;
    if (offset !== previousOffset) {
      story.style.setProperty('--oa-header',`${offset}px`);
      previousOffset = offset;
    }
    if (height !== previousHeight) {
      story.style.setProperty('--oa-nav-height',`${height}px`);
      previousHeight = height;
    }
    // Fit desktop media above the native purchase bar, with the app as a fallback.
    if (window.matchMedia('(min-width:701px)').matches) {
      const cart = document.querySelector('[data-shopsta-sticky-cart][data-ready]') || document.querySelector('.satcb_bar');
      const cartRect = cart?.getBoundingClientRect();
      const cartStyle = cart && getComputedStyle(cart);
      const cartHeight = cartRect && cartStyle.position === 'fixed' && cartStyle.visibility !== 'hidden' && cartStyle.display !== 'none' && cartRect.bottom >= window.innerHeight - 1 && cartRect.top < window.innerHeight
        ? Math.max(0, window.innerHeight - cartRect.top) : 0;
      if (cartHeight !== previousCartHeight) {
        story.style.setProperty('--oa-cart-height', `${cartHeight}px`);
        previousCartHeight = cartHeight;
      }
    }
    const storyRect = story.getBoundingClientRect();
    const progress = Math.max(0,offset-storyRect.top) / Math.max(1,storyRect.height-window.innerHeight+offset);
    story.style.setProperty('--oa-progress',Math.min(1,progress).toFixed(4));
    let active = 0;
    targets.forEach((target,i) => {
      if (target?.getBoundingClientRect().top <= offset+height+60) active=i;
    });
    links.forEach((link,i) => {
      if (i===active) link.setAttribute('aria-current','location');
      else link.removeAttribute('aria-current');
    });
    // Scroll only the label strip, never the page, when the active chapter changes.
    const navWidth = navLinks.clientWidth;
    if (active !== previousActive || navWidth !== previousNavWidth) {
      previousActive = active;
      previousNavWidth = navWidth;
      const current = links[active];
      if (current && navWidth && navLinks.scrollWidth > navWidth) {
        const strip = navLinks.getBoundingClientRect();
        const label = current.getBoundingClientRect();
        const left = label.left - strip.left - 12;
        const right = label.right - strip.right + 12;
        const delta = label.width > navWidth - 24 ? left : left < 0 ? left : right > 0 ? right : 0;
        if (delta) navLinks.scrollBy({
          left: delta,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    }
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled=true;
    requestAnimationFrame(update);
  };
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  if ('ResizeObserver' in window) {
    const observer=new ResizeObserver(schedule);
    observer.observe(nav);
    if (header) observer.observe(header);
    const nativeCart = document.querySelector('[data-shopsta-sticky-cart]');
    if (nativeCart) observer.observe(nativeCart);
  }
  update();
  story.querySelectorAll('.oa-modes').forEach(section => {
    const controls=section.querySelector('.oa-mode-buttons');
    if (!controls) return;
    const buttons=[...controls.querySelectorAll('[data-oa-mode]')];
    const panels=[...section.querySelectorAll('[data-oa-panel]')];
    const show = mode => {
      buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.oaMode===mode)));
      panels.forEach(panel=>{panel.hidden=panel.dataset.oaPanel!==mode;});
      const art = section.querySelector('[data-mode-art]');
      if (art) art.dataset.mode=mode;
    };
    buttons.forEach(button=>button.addEventListener('click',()=>show(button.dataset.oaMode)));
    if (!buttons.length) return;
    show(buttons[0].dataset.oaMode);
    controls.hidden=false;
  });
  // Both mode descriptions and all sections remain readable without JavaScript.
  const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
  const reveals=[...story.querySelectorAll('[data-oa-reveal]')];
  let observer;
  const motion=()=>{
    observer?.disconnect();
    reveals.forEach(item=>item.classList.remove('oa-enter'));
    if(preference.matches||!('IntersectionObserver' in window)) return;
    observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(!entry.isIntersecting)return;
        entry.target.classList.add('oa-enter');
        observer.unobserve(entry.target);
      });
    },{threshold:.08,rootMargin:'0px 0px -24px 0px'});
    reveals.forEach(item=>{if(item.getBoundingClientRect().top>window.innerHeight)observer.observe(item);});
  };
  motion();
  preference.addEventListener('change',motion);
})();
